import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";
import { Link } from "react-router-dom";

export default function Sitemap() {
  const { language } = useLanguage();

  return (
    <StaticPageLayout
      title={language === "hi" ? "साइटमैप" : "Sitemap"}
      subtitle={language === "hi" ? "वेबसाइट के सभी पृष्ठों की सूची" : "Full list of all website pages"}
    >
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
        <div>
          <h3 className="font-bold text-[#2A0A10] border-b border-border/40 pb-2 mb-3">Explore</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" className="hover:text-primary">Home</Link></li>
            <li><Link to="/login" className="hover:text-primary">Login</Link></li>
            <li><Link to="/register" className="hover:text-primary">Register Free</Link></li>
            <li><Link to="/app/browse" className="hover:text-primary">Browse Profiles</Link></li>
            <li><Link to="/success-stories" className="hover:text-primary">Success Stories</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold text-[#2A0A10] border-b border-border/40 pb-2 mb-3">Help & Legal</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-primary">Contact Us</Link></li>
            <li><Link to="/faqs" className="hover:text-primary">FAQs</Link></li>
            <li><Link to="/safety-tips" className="hover:text-primary">Safety Tips</Link></li>
            <li><Link to="/terms" className="hover:text-primary">Terms of Use</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-primary">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-primary">Cookie Policy</Link></li>
            <li><Link to="/grievances" className="hover:text-primary">Grievance Redressal</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold text-[#2A0A10] border-b border-border/40 pb-2 mb-3">Features & Services</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/app/premium" className="hover:text-primary">Membership Plans</Link></li>
            <li><Link to="/app/kundli" className="hover:text-primary">Kundli Matching</Link></li>
            <li><Link to="/app/verify" className="hover:text-primary">Profile Verification</Link></li>
            <li><Link to="/app/chat" className="hover:text-primary">Chat &amp; Connect</Link></li>
          </ul>
        </div>
      </div>
    </StaticPageLayout>
  );
}
